import { Skeleton } from '@material-ui/lab'
import React from 'react'

import useStyles from './styles/PromotionCodesTable.styles'

// Built on the ROW's own grid module, so the placeholder and the real row occupy the same
// tracks — a skeleton on a different grid causes a layout jump the moment data arrives
// (conventions section 7).
const PromotionCodeRowSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <div className={classes.tableRow}>
      {[0, 1, 2, 3].map((cell) => (
        <div key={cell}>
          <Skeleton animation="wave" className={classes.skeleton} />
        </div>
      ))}
    </div>
  )
}

export default PromotionCodeRowSkeleton
